import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Tippy from '@tippyjs/react';

const PackagingProductItem = ({
  isLoading, product, groupId, isActive,
}) => {
  const {
    id,
    title,
    description,
    images,
    tooltip,
    price,
  } = product

  const imgUrl = images?.[0];
  const elId = `product-radio-${id}`

  const tooltipHtml = (
    <Tippy content={tooltip}
      trigger="click"
      placement="bottom"
      delay={0}
      duration={0}
      arrow={false}
      maxWidth={210}
      hideOnClick> 
      <button className="tooltip-trigger">
        <span className="sr-only">Click for more info</span>
      </button>
    </Tippy>
  )

  const priceHtml = (price > 0) && (
    <span className="packaging-product-tile__price">${price / 100}</span>
  )
  
  return (
    <div className="cart-gift-wrap__package-product-tile">
      <label htmlFor={elId}>
        <span className="sr-only">{title}</span>
      </label>

      { tooltip && tooltipHtml }


      <div className="cart-gift-wrap__img-wrapper bg-grey">
        <div className="embed-responsive">
          { imgUrl && (
            <img 
              src={imgUrl}
              sizes="660px"
              alt={title}
              className="embed-responsive-item" />          
          )}
        </div>

      </div>
      <div className="d-flex custom-checkbox-wrapper">
        <input id={elId}
            type="radio"
            name={groupId}
            value={id}
            defaultChecked={isActive}
            disabled={isLoading}
          />
        <span className="custom-checkbox__icon"></span>
        <div>
          <h4 className="packaging-product-tile__title">{title}{priceHtml}</h4>
          <p className="packaging-product-tile__description">{description}</p>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  isLoading: state.cart.isLoading,
});

const mapDispatchToProps = {
};

PackagingProductItem.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  product: PropTypes.objectOf(PropTypes.any).isRequired,
  groupId: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
};

PackagingProductItem.defaultProps = {
  isActive: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(PackagingProductItem);
